import api from '@/libs/axios'

export default {
  async create(payload) {
    const response = await api.post('/admin/stage-milestones', payload)
    return response.data.data.new_document || null
  },
  async getList(params) {
    let response = await api.get('/admin/stage-milestones', {
      params,
    })
    return response.data.data || null
  },
  async get(params) {
    let response = await api.get('/admin/stage-milestones/detail', {
      params,
    })
    return response.data.data.document || null
  },
  async update(payload) {
    let response = await api.put('/admin/stage-milestones', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/stage-milestones', {
      data: payload,
    })
    return response
  },
  async getAll(params) {
    let response = await api.get('/admin/stage-milestones/all', {
      params,
    })
    return response.data.data || null
  },
}
